import { config } from "@fortawesome/fontawesome-svg-core";
import * as React from "react";
import { toIconProp } from "./faIcons.js";
import FontAwesomeIcon from "./reactFontAwesome.js";
// Adding this to prevent fontawesome to inject style tag in header,
// want to inject link stylesheet with css to be compliant with content security policy
config.autoAddCss = false;
/**
 * A component for displaying allowed Font Awesome icons.
 *
 * @see [📝 Documentation](TBD)
 * @see 🏷️ {@link FaIconProps}
 *
 * @example
 * ```jsx
 * <FaIcon width={24} height={22} name={FaIcons.ArrowRight} />
 * ```
 */
const FaIcon = ({ size = "1x", width = 24, height = 24, icon, name, ...rest }) => {
    if (icon == null)
        icon = toIconProp(name);
    return icon == null ? null : (React.createElement(FontAwesomeIcon, { icon: icon, size: size, height: height, width: width, ...rest }));
};
export { FaIcon };
//# sourceMappingURL=faIcon.js.map